import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

  language = JSON.parse(localStorage.getItem('language'))

  selectList2: Array<any> = []
  tmp_selectList: any;
  panelExpanded1 = false;

  @Input()
  enableSearch = true

  @Input()
  isLight = false

  @Input()
  isRequire: false

  @Input()
  selectList = []

  @Input()
  value: string

  @Input()
  defaultTitle = this.language.contactusform11

  @Output()
  fundId: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit() {

    this.selectList2 = this.selectList;
    this.tmp_selectList = this.selectList;


  }

  onListClick(fundName) {
    this.value = fundName.title;
    this.fundId.emit(fundName.value)
  }

  searchFund(term) {

    this.selectList = this.tmp_selectList;
    const x = term.toUpperCase();

    if (term !== '') {
      this.selectList2 = []
      for (let i = 0; i < this.selectList.length; i++) {
        if (this.selectList[i]['title'].indexOf(x) !== -1) {
          this.selectList2.push(this.selectList[i])
        }
      }
    } else {
      this.selectList2 = this.selectList
    }
  }

}
